enum FtthInterventionState {
  KO = 'KO',
  OK = 'OK',
  WAITING_REPORT = 'WAITING_REPORT',
  TO_SEND = 'TO_SEND',
  NO_STATE = 'NO_STATE',
  SERVICE_PENDING = 'SERVICE_PENDING'
}

export default FtthInterventionState;
